import React from 'react';
import { Grid } from '@mui/material';
import ChannelAffinity from './channelAffinity';
import DigitalVsNonDigitalAffinity from './digitalVsNonDigitalAffinity';
import DigitalChannelAffinity from './digitalChannelAffinity';
import PersonalPromotionChannelAffinity from './personalPromotionChannelAffinity';
import Channels from './channels';
import VendorAffinity from './vendorAffinity';
import ContentAffinity from './contentAffinity';
import TopicAndTypes from './topicAndTypes';
import DistributionByLocation from './distributionByLocation';
import DistributionByYearsOfExperience from './distributionByYearsOfExperience';
import FilterBar from './filterBar';

const AffinityHub = (props) => {
    const {} = props;

    return (
        <>
            {/* <FilterBar /> */}
            <Grid container id="affinity-hub" spacing={2}>
                {/* Channel Affinity */}
                <Grid item className="page-break" xs={12}>
                    <ChannelAffinity />
                </Grid>
                {/* Digital Vs NonDigital Affinity */}
                <Grid item className="page-break" xs={12}>
                    <DigitalVsNonDigitalAffinity />
                </Grid>
                {/* Digital Channel Affinity */}
                <Grid item className="page-break" xs={12}>
                    <DigitalChannelAffinity />
                </Grid>
                {/* Personal Promotion Channel Affinity */}
                <Grid item className="page-break" xs={12}>
                    <PersonalPromotionChannelAffinity />
                </Grid>
                {/* Channels */}
                <Grid item className="page-break" xs={12}>
                    <Channels />
                </Grid>
                {/* Vendor Affinity */}
                <Grid item className="page-break" xs={12}>
                    <VendorAffinity />
                </Grid>
                {/* Content Affinity */}
                <Grid item className="page-break" xs={12}>
                    <ContentAffinity />
                </Grid>
                {/* Topic and Types */}
                <Grid item className="page-break" xs={12}>
                    <TopicAndTypes />
                </Grid>
                {/* Distribution By Location */}
                <Grid item className="page-break" xs={12}>
                    <DistributionByLocation />
                </Grid>
                {/* Distribution By Years of Experience */}
                <Grid item className="page-break" xs={12}>
                    <DistributionByYearsOfExperience />
                </Grid>           
            </Grid>
        </>
    );
};

export default AffinityHub;
